var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3000 1600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.779068,0,0,0.779068,685.839,205.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sun"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.47296,0,0,1.47296,-634.948,-174.759)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1342.5,
    cy: 369.5,
    r: 147.5,
    style: {
      fill: "rgb(214,214,214)",
      fillOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.21695,0,0,1.21695,-291.254,-80.1627)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1342.5,
    cy: 369.5,
    r: 147.5,
    style: {
      fill: "rgb(214,214,214)",
      fillOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1342.5,
    cy: 369.5,
    r: 147.5,
    style: {
      fill: "rgb(214,214,214)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "mountains",
    transform: "matrix(1,0,0,1,220,9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.37255,-285,-11.7059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1222,298.5C1222,284.426 1206.32,273 1187,273L917,273C897.683,273 882,284.426 882,298.5C882,312.574 897.683,324 917,324L1187,324C1206.32,324 1222,312.574 1222,298.5Z",
    style: {
      fill: "rgb(245,245,245)",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09885,0,0,1,-524.556,-80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.49,215.748C695.856,196.479 714.12,184.445 734,184.445C753.88,184.445 772.144,196.479 781.51,215.748C894.333,447.872 1169,1012.98 1169,1012.98L328.561,1012.98C322.333,1012.98 316.562,1009.38 313.36,1003.51C310.157,997.645 309.993,990.359 312.927,984.323C370.168,866.554 588.888,416.555 686.49,215.748Z",
    style: {
      fill: "rgb(181,181,181)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.855962,0,0,0.764443,28.7152,158.613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.266,242.954C685.373,218.046 708.673,202.541 734,202.541C759.327,202.541 782.627,218.046 794.734,242.954C891.632,442.314 1077.1,823.9 1144.09,961.724C1149.31,972.468 1149.09,985.499 1143.51,996.015C1137.93,1006.53 1127.81,1012.98 1116.89,1012.98L299,1012.98C299,1012.98 553.636,489.085 673.266,242.954Z",
    style: {
      fill: "rgb(181,181,181)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.696223,0,0,0.746223,978.529,-75.1713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1320.03,1308.03C1325.53,1316.88 1325.54,1327.8 1320.07,1336.67C1314.59,1345.54 1304.46,1351 1293.49,1351C1051.43,1351 58.639,1351 -124.242,1351C-130.495,1351 -136.307,1347.99 -139.619,1343.05C-142.932,1338.1 -143.278,1331.91 -140.534,1326.66C-95.646,1240.89 56.837,949.499 137.578,795.208C149.542,772.346 172.444,756.154 199.271,751.591C226.097,747.029 253.65,754.64 273.49,772.093C294.495,790.57 316.068,809.547 333.884,825.22C343.39,833.582 356.62,837.177 369.451,834.885C382.282,832.593 393.154,824.693 398.677,813.647C438.67,733.66 521.242,568.516 585.308,440.385C602.258,406.484 638.002,384.185 678.057,382.522C718.112,380.859 755.837,400.109 775.947,432.471C934.846,688.179 1230.07,1163.26 1320.03,1308.03Z",
    style: {
      fill: "rgb(203,203,203)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.715997,0,0,0.5,427.238,426.488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M666.154,257.588C681.608,225.793 706.948,206.838 734,206.838C761.052,206.838 786.392,225.793 801.846,257.588C893.443,446.04 1053.78,775.912 1128.51,929.674C1136.39,945.878 1137.32,967.007 1130.94,984.506C1124.56,1002 1111.91,1012.98 1098.12,1012.98C920.019,1012.98 458.88,1012.98 331.83,1012.98C325.444,1012.98 319.587,1007.89 316.63,999.788C313.673,991.682 314.107,981.895 317.755,974.389C377.321,851.837 564.264,467.217 666.154,257.588Z",
    style: {
      fill: "rgb(181,181,181)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.20038,0,0,1,3105.25,-80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691.413,205.62C700.249,187.439 716.465,176.26 734,176.26C751.535,176.26 767.751,187.439 776.587,205.62C886.107,430.946 1169,1012.98 1169,1012.98L330.456,1012.98C323.987,1012.98 318.012,1008.82 314.79,1002.09C311.568,995.357 311.592,987.069 314.852,980.362C375.956,854.646 597.468,398.902 691.413,205.62Z",
    style: {
      fill: "rgb(181,181,181)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.855962,0,0,0.764443,2433.28,158.613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.266,242.954C685.373,218.046 708.673,202.541 734,202.541C759.327,202.541 782.627,218.046 794.734,242.954C891.632,442.314 1077.1,823.9 1144.09,961.724C1149.31,972.468 1149.09,985.499 1143.51,996.015C1137.93,1006.53 1127.81,1012.98 1116.89,1012.98L299,1012.98C299,1012.98 553.636,489.085 673.266,242.954Z",
    style: {
      fill: "rgb(181,181,181)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.696223,0,0,0.746223,1501.47,-75.1713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1320.03,1308.03C1325.53,1316.88 1325.54,1327.8 1320.07,1336.67C1314.59,1345.54 1304.46,1351 1293.49,1351C1051.43,1351 58.639,1351 -124.242,1351C-130.495,1351 -136.307,1347.99 -139.619,1343.05C-142.932,1338.1 -143.278,1331.91 -140.534,1326.66C-95.646,1240.89 56.837,949.499 137.578,795.208C149.542,772.346 172.444,756.154 199.271,751.591C226.097,747.029 253.65,754.64 273.49,772.093C294.495,790.57 316.068,809.547 333.884,825.22C343.39,833.582 356.62,837.177 369.451,834.885C382.282,832.593 393.154,824.693 398.677,813.647C438.67,733.66 521.242,568.516 585.308,440.385C602.258,406.484 638.002,384.185 678.057,382.522C718.112,380.859 755.837,400.109 775.947,432.471C934.846,688.179 1230.07,1163.26 1320.03,1308.03Z",
    style: {
      fill: "rgb(203,203,203)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.37255,-902.028,-151.706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1222,298.5C1222,284.426 1206.32,273 1187,273L917,273C897.683,273 882,284.426 882,298.5C882,312.574 897.683,324 917,324L1187,324C1206.32,324 1222,312.574 1222,298.5Z",
    style: {
      fill: "rgb(245,245,245)",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.848404,0,0,1.09804,1316.42,113.723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1222,298.5C1222,284.426 1207.21,273 1189,273L915.003,273C896.788,273 882,284.426 882,298.5C882,312.574 896.788,324 915.003,324L1189,324C1207.21,324 1222,312.574 1222,298.5Z",
    style: {
      fill: "rgb(245,245,245)",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.250572,0,0,0.490196,34.7731,189.502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1222,298.5C1222,284.426 1199.65,273 1172.11,273L931.886,273C904.353,273 882,284.426 882,298.5C882,312.574 904.353,324 931.886,324L1172.11,324C1199.65,324 1222,312.574 1222,298.5Z",
    style: {
      fill: "rgb(245,245,245)",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.250572,0,0,0.490196,1868.77,228.502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1222,298.5C1222,284.426 1199.65,273 1172.11,273L931.886,273C904.353,273 882,284.426 882,298.5C882,312.574 904.353,324 931.886,324L1172.11,324C1199.65,324 1222,312.574 1222,298.5Z",
    style: {
      fill: "rgb(245,245,245)",
      fillOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.250572,0,0,0.490196,2190.77,351.664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1222,298.5C1222,284.426 1199.65,273 1172.11,273L931.886,273C904.353,273 882,284.426 882,298.5C882,312.574 904.353,324 931.886,324L1172.11,324C1199.65,324 1222,312.574 1222,298.5Z",
    style: {
      fill: "rgb(245,245,245)",
      fillOpacity: 0.7
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "water",
    transform: "matrix(1,0,0,1,220,-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-40,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1097.61,1325.84C1088.77,1325.84 1080.29,1322.33 1074.04,1316.07C1067.79,1309.82 1064.27,1301.34 1064.27,1292.5C1064.27,1291.39 1064.27,1290.28 1064.27,1289.18C1064.27,1280.34 1067.79,1271.86 1074.04,1265.6C1080.29,1259.35 1088.77,1255.84 1097.61,1255.84C1102.52,1255.84 1107.53,1255.84 1112.29,1255.84C1119.44,1255.84 1126.31,1252.99 1131.38,1247.93C1136.44,1242.87 1139.29,1236 1139.29,1228.84C1139.29,1228.84 1139.29,1228.84 1139.29,1228.84C1139.29,1213.93 1127.2,1201.84 1112.29,1201.84C1086.89,1201.84 1048.9,1201.84 1022.27,1201.84C1005.15,1201.84 991.274,1187.96 991.274,1170.84C991.274,1170.84 991.274,1170.84 991.274,1170.84C991.274,1153.72 1005.15,1139.84 1022.27,1139.84C1050.1,1139.84 1090.35,1139.84 1115.65,1139.84C1121.92,1139.84 1127.93,1137.35 1132.36,1132.91C1136.79,1128.48 1139.29,1122.47 1139.29,1116.2C1139.29,1116.2 1139.29,1116.2 1139.29,1116.2C1139.29,1103.14 1128.7,1092.56 1115.65,1092.56C1113.87,1092.56 1112.07,1092.56 1110.27,1092.56C1094.81,1092.56 1082.27,1080.03 1082.27,1064.56C1082.27,1064.35 1082.27,1064.14 1082.27,1063.93C1082.27,1048.81 1094.53,1036.56 1109.64,1036.56L1110.01,1036.56C1117.17,1036.56 1124.04,1033.72 1129.1,1028.65C1134.17,1023.59 1137.01,1016.72 1137.01,1009.56C1137.01,1009.56 1137.01,1009.56 1137.01,1009.56C1137.01,994.649 1124.92,982.561 1110.01,982.561C1096.79,982.561 1080.98,982.561 1068.07,982.561C1061.49,982.561 1055.18,979.949 1050.54,975.3C1045.89,970.651 1043.27,964.345 1043.27,957.769C1043.27,957.769 1043.27,957.768 1043.27,957.768C1043.27,944.075 1054.37,932.976 1068.07,932.976C1085.85,932.976 1109.7,932.976 1127.48,932.976C1141.17,932.976 1152.27,921.876 1152.27,908.184C1152.27,908.183 1152.27,908.183 1152.27,908.182C1152.27,901.607 1154.89,895.301 1159.54,890.651C1164.18,886.002 1170.49,883.39 1177.07,883.39L1382.93,883.39C1389.51,883.39 1395.82,886.002 1400.46,890.651C1405.11,895.301 1407.73,901.607 1407.73,908.182L1407.73,908.184C1407.73,921.876 1418.83,932.976 1432.52,932.976L1463.93,932.976C1477.63,932.976 1488.73,944.075 1488.73,957.768L1488.73,957.769C1488.73,964.345 1486.11,970.651 1481.46,975.3C1476.82,979.949 1470.51,982.561 1463.93,982.561L1419.71,982.561C1412.55,982.561 1405.69,985.406 1400.62,990.469C1395.56,995.532 1392.71,1002.4 1392.71,1009.56L1392.71,1009.56C1392.71,1016.72 1395.56,1023.59 1400.62,1028.65C1405.69,1033.72 1412.55,1036.56 1419.71,1036.56L1509.73,1036.56C1517.15,1036.56 1524.27,1039.51 1529.53,1044.76C1534.78,1050.01 1537.73,1057.13 1537.73,1064.56L1537.73,1064.56C1537.73,1080.03 1525.19,1092.56 1509.73,1092.56C1483.15,1092.56 1443.66,1092.56 1418.63,1092.56C1412.36,1092.56 1406.35,1095.05 1401.91,1099.49C1397.48,1103.92 1394.99,1109.93 1394.99,1116.2L1394.99,1116.2C1394.99,1122.47 1397.48,1128.48 1401.91,1132.91C1406.35,1137.35 1412.36,1139.84 1418.63,1139.84L1444.02,1139.84C1461.13,1139.84 1475.01,1153.72 1475.01,1170.84L1475.01,1170.84C1475.01,1187.96 1461.13,1201.84 1444.01,1201.84L1421.99,1201.84C1414.83,1201.84 1407.96,1204.68 1402.9,1209.75C1397.83,1214.81 1394.99,1221.68 1394.99,1228.84C1394.99,1228.84 1394.99,1228.84 1394.99,1228.84C1394.99,1243.75 1407.08,1255.84 1421.99,1255.84C1459.03,1255.84 1525.57,1255.84 1565.67,1255.84C1584.09,1255.84 1599.01,1270.77 1599.01,1289.18L1599.01,1292.5C1599.01,1310.91 1584.09,1325.84 1565.67,1325.84L1422.49,1325.84C1415.19,1325.84 1408.2,1328.74 1403.04,1333.89C1397.89,1339.05 1394.99,1346.05 1394.99,1353.34C1394.99,1353.34 1394.99,1353.34 1394.99,1353.34C1394.99,1368.53 1407.3,1380.84 1422.49,1380.84C1472.95,1380.84 1580.15,1380.84 1634.67,1380.84C1643.52,1380.84 1652,1384.35 1658.25,1390.6C1664.5,1396.86 1668.01,1405.34 1668.01,1414.18L1668.01,1428.94C1668.01,1437.78 1664.5,1446.26 1658.25,1452.51C1652,1458.76 1643.52,1462.28 1634.67,1462.28L951.614,1462.28C942.772,1462.28 934.291,1458.76 928.039,1452.51C921.787,1446.26 918.274,1437.78 918.274,1428.94L918.274,1414.18C918.274,1405.34 921.787,1396.86 928.039,1390.6C934.291,1384.35 942.772,1380.84 951.614,1380.84C995.322,1380.84 1071.19,1380.84 1111.79,1380.84C1126.97,1380.84 1139.29,1368.53 1139.29,1353.34C1139.29,1353.34 1139.29,1353.34 1139.29,1353.34C1139.29,1346.05 1136.39,1339.05 1131.23,1333.89C1126.07,1328.74 1119.08,1325.84 1111.79,1325.84L1097.61,1325.84Z",
    style: {
      fill: "rgb(181,181,181)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-40,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.935484,0,0,1.23077,137.556,-417.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1177,1129.5C1177,1125.91 1173.17,1123 1168.45,1123L1123.55,1123C1118.83,1123 1115,1125.91 1115,1129.5C1115,1133.09 1118.83,1136 1123.55,1136L1168.45,1136C1173.17,1136 1177,1133.09 1177,1129.5Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.935484,0,0,1.23077,277.435,-334.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1177,1129.5C1177,1125.91 1173.17,1123 1168.45,1123L1123.55,1123C1118.83,1123 1115,1125.91 1115,1129.5C1115,1133.09 1118.83,1136 1123.55,1136L1168.45,1136C1173.17,1136 1177,1133.09 1177,1129.5Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18743,0,0,2,-158.981,-1148.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1177,1129.5C1177,1125.91 1172.09,1123 1166.05,1123L1125.95,1123C1119.91,1123 1115,1125.91 1115,1129.5C1115,1133.09 1119.91,1136 1125.95,1136L1166.05,1136C1172.09,1136 1177,1133.09 1177,1129.5Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.72766,0,0,2.23077,-669.46,-1304.82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1177,1129.5C1177,1125.91 1173.24,1123 1168.61,1123L1123.39,1123C1118.76,1123 1115,1125.91 1115,1129.5C1115,1133.09 1118.76,1136 1123.39,1136L1168.61,1136C1173.24,1136 1177,1133.09 1177,1129.5Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.72766,0,0,2.23077,-748.345,-1162.82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1177,1129.5C1177,1125.91 1173.24,1123 1168.61,1123L1123.39,1123C1118.76,1123 1115,1125.91 1115,1129.5C1115,1133.09 1118.76,1136 1123.39,1136L1168.61,1136C1173.24,1136 1177,1133.09 1177,1129.5Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.05024,0,0,2.23077,-957.522,-1083.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1177,1129.5C1177,1125.91 1173.83,1123 1169.93,1123L1122.07,1123C1118.17,1123 1115,1125.91 1115,1129.5C1115,1133.09 1118.17,1136 1122.07,1136L1169.93,1136C1173.83,1136 1177,1133.09 1177,1129.5Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.47013,0,0,1.47013,-87.6574,-239.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_404",
    serifId: 404
  }, /*#__PURE__*/React.createElement("text", {
    x: "583px",
    y: "802px",
    style: {
      fontFamily: "'Stratum2-Black', 'Stratum2', sans-serif",
      fontWeight: 900,
      fontSize: "600.3px",
      fill: "none",
      stroke: "rgb(229,87,18)",
      strokeWidth: "8.84px"
    }
  }, "40"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.714847,0,0,0.5,2272.42,435.488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.805,254.19C683.07,222.785 708.006,203.858 734.753,203.376C761.5,202.894 786.762,220.916 802.575,251.761C897.907,437.714 1067.68,768.875 1146.97,923.526C1155.21,939.604 1156.45,960.934 1150.17,978.734C1143.89,996.534 1131.16,1007.8 1117.22,1007.88C934.413,1009.02 461.249,1011.97 332.028,1012.77C325.62,1012.81 319.73,1007.75 316.748,999.638C313.767,991.529 314.191,981.722 317.847,974.199C377.838,850.773 566.35,462.926 667.805,254.19Z",
    style: {
      fill: "rgb(181,181,181)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1713.04,351.445)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "0px",
    y: "587.758px",
    style: {
      fontFamily: "'Stratum2-Black', 'Stratum2', sans-serif",
      fontWeight: 900,
      fontSize: "882.519px",
      fill: "none",
      stroke: "rgb(229,87,18)",
      strokeWidth: 13
    }
  }, "4")), /*#__PURE__*/React.createElement("g", {
    id: "tree-left",
    serifId: "tree left",
    transform: "matrix(1,0,0,1,220,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.554392,0,0,0.544485,-472.278,302.358)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.692308,0,0,0.665698,715.231,426.848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,993.766C1915,986.168 1909.17,980 1902,980C1894.83,980 1889,986.168 1889,993.766L1889,1310.23C1889,1317.83 1894.83,1324 1902,1324C1909.17,1324 1915,1317.83 1915,1310.23L1915,993.766Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.79111,-73.5,-949.338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2105.5,1011L2218,1236L1993,1236L2105.5,1011Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.776675,0,0,0.776675,-887.738,8.80075)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.293022,0.389464,1392.07,1096.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.299203,0.39768,1388.13,1126.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.31154,0.414076,1376.04,1143.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1350.75,1143.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1352.87,1188.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.293022,0.389464,3219.93,1095.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.299203,0.39768,3223.87,1125.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.31154,0.414076,3235.96,1142.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3261.25,1142.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3259.13,1187.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.70036,0,0,1.24857,693.484,-347.501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2314,1085.27C2314,1081.93 2309.18,1079.23 2303.24,1079.23C2297.31,1079.23 2292.49,1081.93 2292.49,1085.27L2292.49,1395.97C2292.49,1399.3 2297.31,1402 2303.24,1402C2309.18,1402 2314,1399.3 2314,1395.97L2314,1085.27Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.776675,0,0,0.776675,-1442.92,-56.6749)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.293022,0.389464,1392.07,1096.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.299203,0.39768,1388.13,1126.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.31154,0.414076,1376.04,1143.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1350.75,1143.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1352.87,1188.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.293022,0.389464,3219.93,1095.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.299203,0.39768,3223.87,1125.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.31154,0.414076,3235.96,1142.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3261.25,1142.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3259.13,1187.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.70036,0,0,1.24857,693.484,-347.501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2314,1085.27C2314,1081.93 2309.18,1079.23 2303.24,1079.23C2297.31,1079.23 2292.49,1081.93 2292.49,1085.27L2292.49,1395.97C2292.49,1399.3 2297.31,1402 2303.24,1402C2309.18,1402 2314,1399.3 2314,1395.97L2314,1085.27Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.776675,0,0,0.776675,-1047.39,256.325)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.293022,0.389464,1392.07,1096.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.299203,0.39768,1388.13,1126.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.31154,0.414076,1376.04,1143.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1350.75,1143.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1352.87,1188.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.293022,0.389464,3219.93,1095.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.299203,0.39768,3223.87,1125.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.31154,0.414076,3235.96,1142.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3261.25,1142.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3259.13,1187.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.70036,0,0,1.24857,693.484,-347.501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2314,1085.27C2314,1081.93 2309.18,1079.23 2303.24,1079.23C2297.31,1079.23 2292.49,1081.93 2292.49,1085.27L2292.49,1395.97C2292.49,1399.3 2297.31,1402 2303.24,1402C2309.18,1402 2314,1399.3 2314,1395.97L2314,1085.27Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.554392,0,0,0.544485,-638.777,477.187)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.692308,0,0,0.665698,715.231,426.848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,993.766C1915,986.168 1909.17,980 1902,980C1894.83,980 1889,986.168 1889,993.766L1889,1310.23C1889,1317.83 1894.83,1324 1902,1324C1909.17,1324 1915,1317.83 1915,1310.23L1915,993.766Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.79111,-73.5,-949.338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2105.5,1011L2218,1236L1993,1236L2105.5,1011Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.554392,0,0,0.544485,-1065.93,679.71)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.692308,0,0,0.665698,715.231,426.848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,993.766C1915,986.168 1909.17,980 1902,980C1894.83,980 1889,986.168 1889,993.766L1889,1310.23C1889,1317.83 1894.83,1324 1902,1324C1909.17,1324 1915,1317.83 1915,1310.23L1915,993.766Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.79111,-73.5,-949.338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2105.5,1011L2218,1236L1993,1236L2105.5,1011Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.776675,0,0,0.776675,-1642.56,99.8251)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.293022,0.389464,1392.07,1096.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.299203,0.39768,1388.13,1126.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.31154,0.414076,1376.04,1143.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1350.75,1143.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1352.87,1188.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.293022,0.389464,3219.93,1095.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.299203,0.39768,3223.87,1125.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.31154,0.414076,3235.96,1142.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3261.25,1142.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3259.13,1187.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.70036,0,0,1.24857,693.484,-347.501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2314,1085.27C2314,1081.93 2309.18,1079.23 2303.24,1079.23C2297.31,1079.23 2292.49,1081.93 2292.49,1085.27L2292.49,1395.97C2292.49,1399.3 2297.31,1402 2303.24,1402C2309.18,1402 2314,1399.3 2314,1395.97L2314,1085.27Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.554392,0,0,0.544485,-475.976,858.962)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.692308,0,0,0.665698,715.231,426.848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,993.766C1915,986.168 1909.17,980 1902,980C1894.83,980 1889,986.168 1889,993.766L1889,1310.23C1889,1317.83 1894.83,1324 1902,1324C1909.17,1324 1915,1317.83 1915,1310.23L1915,993.766Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.79111,-73.5,-949.338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2105.5,1011L2218,1236L1993,1236L2105.5,1011Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.776675,0,0,0.776675,-1443.87,414.325)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.293022,0.389464,1392.07,1096.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.299203,0.39768,1388.13,1126.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.31154,0.414076,1376.04,1143.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1350.75,1143.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1352.87,1188.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.293022,0.389464,3219.93,1095.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.299203,0.39768,3223.87,1125.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.31154,0.414076,3235.96,1142.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3261.25,1142.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3259.13,1187.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.70036,0,0,1.24857,693.484,-347.501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2314,1085.27C2314,1081.93 2309.18,1079.23 2303.24,1079.23C2297.31,1079.23 2292.49,1081.93 2292.49,1085.27L2292.49,1395.97C2292.49,1399.3 2297.31,1402 2303.24,1402C2309.18,1402 2314,1399.3 2314,1395.97L2314,1085.27Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "tree-right",
    serifId: "tree right",
    transform: "matrix(-1,0,0,1,2769.88,7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.554392,0,0,0.544485,-413.278,313.687)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.692308,0,0,0.665698,715.231,426.848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,993.766C1915,986.168 1909.17,980 1902,980C1894.83,980 1889,986.168 1889,993.766L1889,1310.23C1889,1317.83 1894.83,1324 1902,1324C1909.17,1324 1915,1317.83 1915,1310.23L1915,993.766Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.79111,-73.5,-949.338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2105.5,1011L2218,1236L1993,1236L2105.5,1011Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.776675,0,0,0.776675,-832.738,-12.2559)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.293022,0.389464,1392.07,1096.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.299203,0.39768,1388.13,1126.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.31154,0.414076,1376.04,1143.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1350.75,1143.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1352.87,1188.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.293022,0.389464,3219.93,1095.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.299203,0.39768,3223.87,1125.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.31154,0.414076,3235.96,1142.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3261.25,1142.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3259.13,1187.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.70036,0,0,1.24857,693.484,-347.501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2314,1085.27C2314,1081.93 2309.18,1079.23 2303.24,1079.23C2297.31,1079.23 2292.49,1081.93 2292.49,1085.27L2292.49,1395.97C2292.49,1399.3 2297.31,1402 2303.24,1402C2309.18,1402 2314,1399.3 2314,1395.97L2314,1085.27Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.776675,0,0,0.776675,-1361.04,-63.6749)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.293022,0.389464,1392.07,1096.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.299203,0.39768,1388.13,1126.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.31154,0.414076,1376.04,1143.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1350.75,1143.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1352.87,1188.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.293022,0.389464,3219.93,1095.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.299203,0.39768,3223.87,1125.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.31154,0.414076,3235.96,1142.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3261.25,1142.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3259.13,1187.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.70036,0,0,1.24857,693.484,-347.501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2314,1085.27C2314,1081.93 2309.18,1079.23 2303.24,1079.23C2297.31,1079.23 2292.49,1081.93 2292.49,1085.27L2292.49,1395.97C2292.49,1399.3 2297.31,1402 2303.24,1402C2309.18,1402 2314,1399.3 2314,1395.97L2314,1085.27Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.456621,0.889661,-0.889661,-0.456621,2323.96,1060.74)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.253535,-0.190753,0.227582,0.302487,43.0949,1089.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.253535,-0.190753,0.232384,0.308868,40.0341,1113.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.253535,-0.190753,0.241965,0.321603,30.6445,1126.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.253535,-0.190753,0.261162,0.347119,11.0028,1126.35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.253535,-0.190753,0.261162,0.347119,12.6472,1161.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.253535,-0.190753,-0.227582,0.302487,1462.74,1089.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.253535,-0.190753,-0.232384,0.308868,1465.8,1112.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.253535,-0.190753,-0.241965,0.321603,1475.19,1125.82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.253535,-0.190753,-0.261162,0.347119,1494.83,1125.96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.253535,-0.190753,-0.261162,0.347119,1493.19,1160.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.543952,0,0,0.969736,-499.482,-31.5472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2314,1307.18L2314,1085.27C2314,1081.93 2309.18,1079.23 2303.24,1079.23C2297.31,1079.23 2292.49,1081.93 2292.49,1085.27L2292.49,1307.18C2295.44,1305.82 2299.18,1305.04 2303.24,1305.04C2307.3,1305.04 2311.05,1305.82 2314,1307.18Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.543952,0,0,0.630108,-385.482,343.803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2292.49,1322.5L2292.49,1362.88C2292.49,1366.21 2297.31,1368.91 2303.24,1368.91C2309.18,1368.91 2314,1366.21 2314,1362.88L2314,1322.5C2311.05,1323.86 2307.3,1324.64 2303.24,1324.64C2299.18,1324.64 2295.44,1323.86 2292.49,1322.5Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.543952,0,0,0.630108,-492.482,265.513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2292.49,1322.5L2292.49,1362.88C2292.49,1366.21 2297.31,1368.91 2303.24,1368.91C2309.18,1368.91 2314,1366.21 2314,1362.88L2314,1322.5C2311.05,1323.86 2307.3,1324.64 2303.24,1324.64C2299.18,1324.64 2295.44,1323.86 2292.49,1322.5Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.543952,0,0,0.630108,-645.482,427.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2292.49,1322.5L2292.49,1362.88C2292.49,1366.21 2297.31,1368.91 2303.24,1368.91C2309.18,1368.91 2314,1366.21 2314,1362.88L2314,1322.5C2311.05,1323.86 2307.3,1324.64 2303.24,1324.64C2299.18,1324.64 2295.44,1323.86 2292.49,1322.5Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.543952,0,0,0.630108,-718.188,244.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2292.49,1322.5L2292.49,1362.88C2292.49,1366.21 2297.31,1368.91 2303.24,1368.91C2309.18,1368.91 2314,1366.21 2314,1362.88L2314,1322.5C2311.05,1323.86 2307.3,1324.64 2303.24,1324.64C2299.18,1324.64 2295.44,1323.86 2292.49,1322.5Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.543952,0,0,0.630108,-964.482,378.513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2292.49,1322.5L2292.49,1362.88C2292.49,1366.21 2297.31,1368.91 2303.24,1368.91C2309.18,1368.91 2314,1366.21 2314,1362.88L2314,1322.5C2311.05,1323.86 2307.3,1324.64 2303.24,1324.64C2299.18,1324.64 2295.44,1323.86 2292.49,1322.5Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.554392,0,0,0.544485,-1013.93,713.439)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.692308,0,0,0.665698,715.231,426.848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,993.766C1915,986.168 1909.17,980 1902,980C1894.83,980 1889,986.168 1889,993.766L1889,1310.23C1889,1317.83 1894.83,1324 1902,1324C1909.17,1324 1915,1317.83 1915,1310.23L1915,993.766Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.79111,-73.5,-949.338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2105.5,1011L2218,1236L1993,1236L2105.5,1011Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.776675,0,0,0.776675,-1552.79,92.8251)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.293022,0.389464,1392.07,1096.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.299203,0.39768,1388.13,1126.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.31154,0.414076,1376.04,1143.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1350.75,1143.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1352.87,1188.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.293022,0.389464,3219.93,1095.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.299203,0.39768,3223.87,1125.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.31154,0.414076,3235.96,1142.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3261.25,1142.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3259.13,1187.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.70036,0,0,1.24857,693.484,-347.501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2314,1085.27C2314,1081.93 2309.18,1079.23 2303.24,1079.23C2297.31,1079.23 2292.49,1081.93 2292.49,1085.27L2292.49,1395.97C2292.49,1399.3 2297.31,1402 2303.24,1402C2309.18,1402 2314,1399.3 2314,1395.97L2314,1085.27Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.554392,0,0,0.544485,-395.976,858.962)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.692308,0,0,0.665698,715.231,426.848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,993.766C1915,986.168 1909.17,980 1902,980C1894.83,980 1889,986.168 1889,993.766L1889,1310.23C1889,1317.83 1894.83,1324 1902,1324C1909.17,1324 1915,1317.83 1915,1310.23L1915,993.766Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.79111,-73.5,-949.338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2105.5,1011L2218,1236L1993,1236L2105.5,1011Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.776675,0,0,0.776675,-1339.87,432.325)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.293022,0.389464,1392.07,1096.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.299203,0.39768,1388.13,1126.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.31154,0.414076,1376.04,1143.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1350.75,1143.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.326436,-0.245602,0.336257,0.446929,1352.87,1188.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.293022,0.389464,3219.93,1095.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.896C1915,984.882 1909.17,980 1902,980C1894.83,980 1889,984.882 1889,990.896L1889,1313.1C1889,1319.12 1894.83,1324 1902,1324C1909.17,1324 1915,1319.12 1915,1313.1L1915,990.896Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.299203,0.39768,3223.87,1125.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.671C1915,984.782 1909.17,980 1902,980C1894.83,980 1889,984.782 1889,990.671L1889,1313.33C1889,1319.22 1894.83,1324 1902,1324C1909.17,1324 1915,1319.22 1915,1313.33L1915,990.671Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.31154,0.414076,3235.96,1142.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,990.249C1915,984.592 1909.17,980 1902,980C1894.83,980 1889,984.592 1889,990.249L1889,1313.75C1889,1319.41 1894.83,1324 1902,1324C1909.17,1324 1915,1319.41 1915,1313.75L1915,990.249Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3261.25,1142.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.326436,-0.245602,-0.336257,0.446929,3259.13,1187.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915,989.495C1915,984.255 1909.17,980 1902,980C1894.83,980 1889,984.255 1889,989.495L1889,1314.51C1889,1319.75 1894.83,1324 1902,1324C1909.17,1324 1915,1319.75 1915,1314.51L1915,989.495Z",
    style: {
      fill: "rgb(214,214,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.70036,0,0,1.24857,693.484,-347.501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2314,1085.27C2314,1081.93 2309.18,1079.23 2303.24,1079.23C2297.31,1079.23 2292.49,1081.93 2292.49,1085.27L2292.49,1395.97C2292.49,1399.3 2297.31,1402 2303.24,1402C2309.18,1402 2314,1399.3 2314,1395.97L2314,1085.27Z",
    style: {
      fill: "rgb(192,192,192)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.760926,0,0,1.06703,2151.68,-102.378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1512.3,1286.3C1512.3,1278.74 1503.69,1272.6 1493.09,1272.6L1378.21,1272.6C1367.61,1272.6 1359,1278.74 1359,1286.3C1359,1293.86 1367.61,1300 1378.21,1300L1493.09,1300C1503.69,1300 1512.3,1293.86 1512.3,1286.3Z",
    style: {
      fill: "rgb(201,201,201)",
      fillOpacity: 0.6
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.13756,0,0,1.2116,-220.639,-196.349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1604,936.189C1604,931.625 1600.05,927.919 1595.19,927.919L1481.95,927.919C1477.09,927.919 1473.14,931.625 1473.14,936.189L1473.14,952.73C1473.14,957.294 1477.09,961 1481.95,961L1595.19,961C1600.05,961 1604,957.294 1604,952.73L1604,936.189Z",
    style: {
      fill: "rgb(181,181,181)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.5015cee43424cfdd6d32e62f386b1725.svg";
export { ForwardRef as ReactComponent };